import Repository from './repository'

export default {
    /**
     * Busca todas as configuracoes de IA
     */
    getAll() {
        return Repository.get('ai-config')
    },

    /**
     * Busca a configuracao global
     */
    getGlobalConfig() {
        return Repository.get('ai-config/global')
    },

    /**
     * Atualiza a configuracao global
     */
    updateGlobalConfig(data) {
        return Repository.post('ai-config/global', data)
    },

    /**
     * Atualiza a API Key
     */
    updateApiKey(apiKey) {
        return Repository.post('ai-config/api-key', { api_key: apiKey })
    },

    /**
     * Remove a API Key customizada
     */
    removeApiKey() {
        return Repository.delete('ai-config/api-key')
    },

    /**
     * Busca todos os prompts
     */
    getPrompts() {
        return Repository.get('ai-config/prompts')
    },

    /**
     * Cria um novo prompt
     */
    createPrompt(data) {
        return Repository.post('ai-config/prompts', data)
    },

    /**
     * Atualiza um prompt
     */
    updatePrompt(id, data) {
        return Repository.put(`ai-config/prompts/${id}`, data)
    },

    /**
     * Testa a conexao com a OpenAI
     */
    testConnection() {
        return Repository.post('ai-config/test-connection')
    }
}
